let setting_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'settings', name: 'settings.list', component: () => import('./pages/Index.vue') },
      { path: 'settings/create', name: 'settings.create', component: () => import('./pages/Create.vue') },
      { path: 'settings/:id/edit', name: 'settings.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default setting_routes;
